const { isEmpty, fromPairs, } = require('lodash');

const { malls } = require('../config');

const mappingValuesOf = (mall, values) => fromPairs((malls[mall]?.mappingItems || []).map(_ => [_.name, String(values?.[_.name] ?? '')]));

const hasMappingValues = (mall, values) => !isEmpty(mappingValuesOf(mall, values)[malls[mall]?.mappingItems[0]?.name]);

// 1つのモールSKUが複数のLOGISP商品に紐付かないよう、モールSKUからIDを決める。
// null と '' は受注側で同一視しているため、どちらも '' として扱う。
const productMallMappingId = (shop, values) => [shop.id, ...Object.values(mappingValuesOf(shop.mall, values))].map(encodeURIComponent).join(':');

const mallSkuLabelOf = (mall, values) => Object.values(mappingValuesOf(mall, values)).filter(_ => !isEmpty(_)).join(' / ');

const findShopifyMallProductCache = async (tenant, shop, shopifySku) => {
  const { docs: [mallProductDoc] } = await tenant.ref.collection('mallProducts').where('shopId', '==', shop.id).where('sku', '==', shopifySku).limit(1).get();
  return {
    shopifyVariantId: mallProductDoc?.data().mallVariantId ?? null,
    shopifyInventoryItemId: mallProductDoc?.data().mallInventoryItemId ?? null,
  };
};

const saveProductMallMapping = async (tenant, shop, { productId, values, cacheValues, prevMapping, }) => {
  const mappingValues = mappingValuesOf(shop.mall, values);
  const ref = tenant.ref.collection('productMallMappings').doc(productMallMappingId(shop, mappingValues));
  const isSameKey = prevMapping?.id === ref.id;
  const existingDoc = await ref.get();
  if (existingDoc.exists && !isSameKey) {
    const existingProductId = existingDoc.data().productId;
    throw new Error(existingProductId === productId ? `「${mallSkuLabelOf(shop.mall, mappingValues)}」は既にこの商品に紐付いています` : `「${mallSkuLabelOf(shop.mall, mappingValues)}」は既に別の商品(${tenant.id}-${existingProductId})に紐付いています`);
  }

  // キーが変わらない編集では、在庫連携用にキャッシュしたモール側IDを残す。
  const resolvedCacheValues = cacheValues ?? (isSameKey ? {} : shop.mall === 'shopify' ? await findShopifyMallProductCache(tenant, shop, mappingValues.shopifySku) : {});
  const batch = ref.firestore.batch();
  batch.set(ref, {
    shopId: shop.id,
    mall: shop.mall,
    productId,
    ...mappingValues,
    ...resolvedCacheValues,
    ...(!isSameKey && { createdAt: new Date() }),
    updatedAt: new Date(),
  }, { merge: true });
  if (prevMapping != null && !isSameKey) batch.delete(prevMapping.ref);
  await batch.commit();
};

module.exports = {
  mappingValuesOf,
  hasMappingValues,
  productMallMappingId,
  saveProductMallMapping,
};
